/* Remora price slider — dual-handle slider + quick price chips.
   Replaces the theme's two price boxes; the original inputs stay (hidden) so filtering keeps working. */
(function () {
  /* Quick price chips: [min, max] — null = no limit. Edit to fit your prices. */
  var PRESETS = [
    { label: 'עד 250 ₪', min: null, max: 250 },
    { label: '250–300 ₪', min: 250, max: 300 },
    { label: '300 ₪ ומעלה', min: 300, max: null }
  ];

  function fmt(n) { return '₪' + Number(n).toLocaleString('he-IL'); }

  function build(pr) {
    if (pr.dataset.rsReady) return;
    var inputs = pr.querySelectorAll('input');
    if (inputs.length < 2) return;
    var minIn = inputs[0], maxIn = inputs[1];
    var floor = 0;
    var ceil = Math.ceil(parseFloat(maxIn.getAttribute('data-max') || maxIn.getAttribute('max') || '0'));
    if (!ceil) return;
    pr.dataset.rsReady = '1';

    var curMin = minIn.value !== '' ? parseFloat(minIn.value) : floor;
    var curMax = maxIn.value !== '' ? parseFloat(maxIn.value) : ceil;

    var chips = PRESETS.filter(function (p) { return (p.min || 0) < ceil; }).map(function (p, i) {
      return '<button type="button" class="rs__chip" data-i="' + i + '">' + p.label + '</button>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.className = 'rs';
    wrap.innerHTML =
      '<div class="rs__values" dir="ltr">' +
        '<span class="rs__val rs__val--lo"></span><span class="rs__dash"></span><span class="rs__val rs__val--hi"></span>' +
      '</div>' +
      '<div class="rs__slider" dir="ltr">' +
        '<div class="rs__track"></div><div class="rs__fill"></div>' +
        '<span class="rs__bubble rs__bubble--lo"></span><span class="rs__bubble rs__bubble--hi"></span>' +
        '<input type="range" class="rs__range rs__range--lo" min="' + floor + '" max="' + ceil + '" step="1" value="' + curMin + '" aria-label="מחיר מינימלי">' +
        '<input type="range" class="rs__range rs__range--hi" min="' + floor + '" max="' + ceil + '" step="1" value="' + curMax + '" aria-label="מחיר מקסימלי">' +
      '</div>' +
      (chips ? '<div class="rs__chips">' + chips + '</div>' : '');
    pr.insertAdjacentElement('afterend', wrap);
    pr.classList.add('rs-hidden');

    var rLo = wrap.querySelector('.rs__range--lo');
    var rHi = wrap.querySelector('.rs__range--hi');
    var fill = wrap.querySelector('.rs__fill');
    var vLo = wrap.querySelector('.rs__val--lo');
    var vHi = wrap.querySelector('.rs__val--hi');
    var bLo = wrap.querySelector('.rs__bubble--lo');
    var bHi = wrap.querySelector('.rs__bubble--hi');
    var chipEls = wrap.querySelectorAll('.rs__chip');
    var span = ceil - floor;

    function pct(v) { return (v - floor) / span * 100; }

    function update(e) {
      var lo = +rLo.value, hi = +rHi.value;
      if (lo > hi) {
        if (e && e.target === rLo) { lo = hi; rLo.value = lo; }
        else { hi = lo; rHi.value = hi; }
      }
      fill.style.left = pct(lo) + '%';
      fill.style.right = (100 - pct(hi)) + '%';
      bLo.style.left = pct(lo) + '%';
      bHi.style.left = pct(hi) + '%';
      vLo.textContent = bLo.textContent = fmt(lo);
      vHi.textContent = bHi.textContent = fmt(hi);
      rLo.style.zIndex = lo > ceil - span * 0.1 ? 5 : 3;
      chipEls.forEach(function (c) {
        var p = PRESETS[+c.dataset.i];
        var pMin = p.min == null ? floor : p.min, pMax = p.max == null ? ceil : Math.min(p.max, ceil);
        c.classList.toggle('is-active', lo === pMin && hi === pMax);
      });
    }

    function commit() {
      var lo = +rLo.value, hi = +rHi.value;
      minIn.value = lo > floor ? lo : '';
      maxIn.value = hi < ceil ? hi : '';
      maxIn.dispatchEvent(new Event('input', { bubbles: true }));
    }

    [rLo, rHi].forEach(function (r) {
      r.addEventListener('input', function (e) { e.stopPropagation(); wrap.classList.add('is-dragging'); update(e); });
      r.addEventListener('change', function (e) { e.stopPropagation(); wrap.classList.remove('is-dragging'); commit(); });
      r.addEventListener('pointerup', function () { wrap.classList.remove('is-dragging'); });
      r.addEventListener('blur', function () { wrap.classList.remove('is-dragging'); });
    });

    chipEls.forEach(function (c) {
      c.addEventListener('click', function () {
        var p = PRESETS[+c.dataset.i];
        var active = c.classList.contains('is-active');
        rLo.value = active || p.min == null ? floor : p.min;
        rHi.value = active || p.max == null ? ceil : Math.min(p.max, ceil);
        update();
        commit();
      });
    });

    update();
  }

  function initAll() { document.querySelectorAll('price-range').forEach(build); }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();